<template>
  <!-- выбор формата значений каналов: проценты или абсолютные числа -->
  <DropDown type="origin" :title="titles[modelValue]" :divider="true">
    <template v-slot:items>
      <DropDownItem
        @selectItem="select"
        :text="$t('main.marketingChannels.valuePicker.percentValue')"
        value="percent"
      />
      <DropDownItem
        @selectItem="select"
        :text="$t('main.marketingChannels.valuePicker.absoluteValue')"
        value="absolute"
      />
    </template>
  </DropDown>
</template>

<script>
import DropDown from '@/components/shared/drop-down/DropDown.vue'
import DropDownItem from '@/components/shared/drop-down/DropDownItem.vue'

export default {
  components: { DropDown, DropDownItem },
  props: {
    modelValue: {
      type: String,
      default: 'percent', // percent | absolute
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      titles: {
        percent: '%',
        absolute: '#',
      },
    }
  },
  methods: {
    select(value) {
      this.$emit('update:modelValue', value)
    },
  },
}
</script>
